export const ACCESSORY_WALL_MIN_LENGTH = 40
export const ACCESSORY_CIRCLE_RADIUS = 10
export const ACCESSORY_CIRCLE_STROKE_WIDTH = 1
export const ACCESSORY_LABEL_FONT_SIZE = 20
export const ACCESSORY_LABEL_VERTICAL_OFFSET = 7
